import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import SideContentTemplate from "../SideContentTemplate";

const InvestAnywhereAnytime = (props) => {
  const data = useStaticQuery(graphql`
    query {
      imageGooglePlay: file(relativePath: { eq: "images/google-play.svg" }) {
        publicURL
      }
      imageAppleStore: file(relativePath: { eq: "images/apple-store.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      {props.content.edges && (
        <>
          <SideContentTemplate
            backgroundColor="blue"
            backgroundImg="invest-anywhere-anytime"
            headerHTML={props.content.edges[0].node.acfPartials.pHeading}
            headerClassNames="text-center text-lg-left"
            contentHTML={props.content.edges[0].node.acfPartials.pContent}
            contentClassNames="text-center text-lg-left"
            imgURL={
              props.content.edges[0].node.acfPartials.pIcon.localFile.publicURL
            }
            imgMaxWidth={500}
            isImgHiddenOnMobile={false}
          >
            <ol className="list-inline text-center text-lg-left">
              <li className="list-inline-item">
                <a
                  href="https://zipmex.onelink.me/8NSq/15940e3a"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  <img
                    className="img-fluid"
                    src={data.imageAppleStore.publicURL}
                    alt="Download on Apple Store"
                    height={50}
                    width={160}
                    loading="lazy"
                  />
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://zipmex.onelink.me/8NSq/15940e3a"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  <img
                    className="img-fluid"
                    src={data.imageGooglePlay.publicURL}
                    alt="Download on Google Play"
                    height={50}
                    width={160}
                    loading="lazy"
                  />
                </a>
              </li>
            </ol>
          </SideContentTemplate>
        </>
      )}
    </>
  );
};

export default InvestAnywhereAnytime;
